import React from "react";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import classes from "./styles/style.module.css";
import RadioItem from "./RadioItem";

const RadioFieldsElement = ({
  id,
  req,
  title,
  subtitle,
  desc,
  selectionList,
  value,
  handleChange,
  formId,
  fieldId,
}) => {
  const handleRadioChange = (event) => {
    const selectedValue = event.target.value;
    handleChange(id, selectedValue);
  };

  return (
    <div className="my-4">
      <FormControl component="fieldset">
        <div>
          <p className={classes.formTitle}>
            {title} <span className="text-danger">{req ? "*" : null}</span>
          </p>
        </div>
        <div className="px-2">
          {subtitle && <p className={classes.subTitle}>{subtitle}</p>}
          <RadioGroup
            value={value || ""}
            onChange={handleRadioChange}
            aria-label={title}
            name={id}
          >
            {selectionList &&
              selectionList.map((item) => (
                <RadioItem
                  key={item._id}
                  item={item}
                  formId={formId}
                  fieldId={fieldId}
                />
              ))}
          </RadioGroup>
          {desc && <p className={classes.desc}>{desc}</p>}
        </div>
      </FormControl>
    </div>
  );
};

export default RadioFieldsElement;
